import React from 'react'
import { useNavigate } from "react-router-dom";
import styled from 'styled-components'
import { Stack, Badge, Grid, GridItem, Button, Box } from '@chakra-ui/react'
import swal from 'sweetalert';
import APIConfig from "../../api/APIConfig";

const WrapText = styled.section`
    display: flex;
    flex-direction: row;
    font-size: 13px;
    width: 300px;
    min-height: 25px;
    

    @media screen and (max-width: 873px){
        margin-left: 38px;
        margin-bottom: 10px;
        width: 219px;
     };
`;

const ImageCard = styled.img`
    width: 9vw;
    height: 20vh;
    margin-top: 20px;
    margin-bottom: 20px;
`;

let aksi = ""

function CardStatusPendaftaran ({
    id,
    idPeserta,
    perusahaan,
    kegiatan,
    aktivitas,
    status,
    pembayaran,
    nominal,
    logo,
    kodeUnik,}) {
   
    if (status=="Aktif") {
        aksi = "Aktif";
    }

    const navigate = useNavigate();

    const lanjutLowongan = async(e) => {
        e.preventDefault();
        swal({
            title: "Apakah kamu yakin ingin melanjutkan lowongan ini?",
            text: "Pilihan kamu tidak dapat dibatalkan. Jika kamu melanjutkan lowongan ini, maka semua lowongan lain akan dibatalkan.",
            icon: "warning",
            buttons: {
                yes: {
                text: "Ya",
                value: "yes"
                },
                no: {
                text: "Tidak",
                value: "no"
                }
            }
        }).then((value) => {
            if (value === "yes") {
                APIConfig.put(`/v1/lowonganPeserta/statusPenerimaan/${id}`, {
                    statusPenerimaan: "Aktif"
                })
                swal({
                    title: "Kamu berhasil melanjutkan lowongan ini!",
                    icon: "success",
                    button: "OK",
                })
                .then(() => {
                    window.location.reload();
                })
                .catch((error) => {
                    console.log(error);
                })
            }
            return false;
        })
    };
    console.log("STATUS" + status)

    const batalLowongan = async(e) => {  
        e.preventDefault();
        swal({
            title: "Apakah kamu yakin ingin membatalkan lowongan ini?",
            text: "Pilihan kamu tidak dapat dibatalkan.",
            icon: "warning",
            buttons: {
                yes: {
                text: "Ya",
                value: "yes"
                },
                no: {
                text: "Tidak",
                value: "no"
                }
            },
        }).then((value) => {
            if (value === "yes") {
                APIConfig.put(`/v1/lowonganPeserta/statusPenerimaan/${id}`, {
                    statusPenerimaan: "Batal"
                })
                swal({
                    title: "Kamu berhasil membatalkan lowongan ini!",
                    icon: "success",
                    button: "OK",
                })
                .then(() => {
                    window.location.reload();
                })
                .catch((error) => {
                    console.log(error);
                })
            }
            return false;
        })
    };
    
    return (
        <Grid border='2px' borderColor='gray.200' templateColumns='repeat(3, 1fr)' gap={3}  style={{width:'800px'}}>
            <GridItem >
            <ImageCard src={logo}/>
            </GridItem>
          
            <Stack>
            <GridItem  style={{marginTop:'30px', marginRight:'30px'}}>
                <WrapText >
                    <span style={{fontWeight: '600',fontSize: '18px'}}>{perusahaan}</span>
                </WrapText>
                <br></br>
                <WrapText>
                    <span style={{fontSize: '14px'}}>{kegiatan}</span>
                </WrapText>
                <WrapText>
                <div style={{fontWeight: '600', fontSize: '9px', marginBottom: '5px'}}>{pembayaran}</div>
                </WrapText>
                <WrapText>
                <div style={{fontWeight: '600', fontSize: '9px', marginBottom: '5px'}}>{nominal==null ? 'Lowongan ini tidak berbayar' : kodeUnik!=null ? nominal+" (Termasuk kode unik 3 digit terakhir)" : nominal}</div>
                </WrapText>
                <WrapText>
                <div style={{fontWeight: '600', fontSize: '9px', marginBottom: '5px'}}>{aktivitas}</div>
                </WrapText>
            </GridItem>   
            </Stack>  
            <GridItem style={{marginTop:'20px', display:'block', marginRight: '0'}}>
                <WrapText>
                    {status == "Aktif" ? (
                        <span>
                            <Badge p={2} m={2} colorScheme='green' fontSize='10px' style={{display:'block', margin:'auto'}}>Lamaran: {status}</Badge>
                        </span>
                        ) : (
                        status == "Batal" ? (
                            <span>
                                <Badge p={2} m={2} colorScheme='red' fontSize='10px' style={{display:'block', margin:'auto'}}>Lamaran: {status}</Badge>
                            </span>
                        ) : (
                            <span>
                                <Badge p={2} m={2} colorScheme='purple' fontSize='10px' style={{display:'block', margin:'auto'}}>Lamaran: {status}</Badge>
                            </span>
                    ))}
                </WrapText>

                {aksi!="Aktif" && status=="Diterima" ? (
                <WrapText style={{marginTop:'20px'}}>
                    <span>
                            <Box>
                            <Button 
                                onClick={(e) => lanjutLowongan(e)}
                                size='sm' rounded={'xl'} colorScheme='green' variant='solid' fontSize={'xs'} margin={'0 0px'}>
                                Lanjut
                            </Button>
                            </Box>
                        
                    </span>
                    <span>         
                            <Box>
                            <Button 
                                onClick={(e) => batalLowongan(e)}
                                size='sm' rounded={'xl'} colorScheme='red' variant='solid' fontSize={'xs'} margin={'0 10px'}>
                                Batal
                            </Button>
                            </Box>
                    </span>
                </WrapText>
                ) : null}

                {status=="Aktif" ? (
                    <WrapText style={{marginTop:'20px'}}>      
                        <Box>
                        {nominal==null ?
                            null :
                            <Button 
                                onClick={() => navigate(`/peserta/kegiatanku/buktipembayaran/${idPeserta}`)}
                                size='sm' rounded={'xl'} colorScheme='purple' variant='solid' fontSize={'xs'} margin={'0 0px'}>
                                Pembayaran
                            </Button>
                        }
                        </Box>
                    </WrapText>
                ) : null}
            </GridItem>
    </Grid>
    )
}

export default CardStatusPendaftaran;